module.exports = __webpack_public_path__ + "static/media/lillie.c81db66e.png";